const getPriceEvaluation = (price: number, confidenceMin: number, confidenceMax: number): PriceEvaluation => {
    // Expensive
    if (price > confidenceMax) {
        return 'expensive';
    }
    // Very good
    if (price < confidenceMin) {
        return 'veryGood';
    }
    // Good
    return 'good';
};

export default getPriceEvaluation;
